import styled from 'styled-components';

export const StyledHome = styled.div`
  min-height: calc(100vh - 6vh - 8vh);
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: var(--space-7) var(--space-4) var(--space-9);

  @media (min-width: 786px) {
    gap: var(--space-9);
    padding: var(--space-9) var(--space-6);
  }

  @media (min-width: 1200px) {
    padding: var(--space-10) var(--space-6);
  }
`;
